(function ($) {



    $(document).on('ready', function () {

        $('.content-wrap-tables').each(function() {
            const $thisArticle = $(this);
            
            $thisArticle.find('table').each(function () {
                const $tableWrapEl = $('<div class="content-table-wrap"></div>');
                $tableWrapEl.insertBefore( $(this) );
                $(this).appendTo($tableWrapEl);
            })
        })

    });


})(jQuery);